<template>
  <main class="hero">
    <!-- <img class="hero__image" src="https://rixtrema.com/blog/wp-content/uploads/2021/12/gifntext-1.gif" alt="Hero image" /> -->
    <img class="hero__image" :src="img.gif" />
    <section class="hero__content">
      <h3 class="title">
        10 DAYS TO PORTFOLIO RISK MASTERY: FREE CHALLENGE:
      </h3>
      <ul class="list">
        <li class="list__item" v-for="event in events" :key="event.id">
          <span class="list__count">{{ event.id }}.</span>
          <div>
            <p class="list__text">
              {{ event.title }}
            </p>
            <ul class="simple-list">
              <li
                class="simple-list__item"
                v-for="(subtitle, i) in event.subtitles"
                :key="i"
              >
                {{ subtitle }}
              </li>
            </ul>
          </div>
        </li>
      </ul>
      <CtaButton size="2.3rem" @click.native="showModal">
        CLICK HERE TO REGISTER FOR FREE CHALLENGE
      </CtaButton>
    </section>
    <Modal :show="showModal" @close="closeModal" />
  </main>
</template>

<script>
import Modal from '../form/Modal'
import CtaButton from '../CtaButton'
export default {
  components: {
    Modal,
    CtaButton
  },
  data() {
    return {
      events: [
        {
          id: 1,
          title:
            'May 10 at Noon/12 PM EST: Session 1: Foundations of Risk - Part 1.',
          // subtitles: [
          //   '',            
          // ]
        },
        {
          id: 2,
          title:
            'May 12 at Noon/12 PM EST: Session 2: Foundations of Risk - Part 2.',
          // subtitles: [
          //   'How to Become a Trusted Thought Leader to Plan Sponsors with Content',            
          // ]
        },
        {
          id: 3,
          title:
            'May 17 at Noon/12 PM EST: Session 3: Equity Risk Management - Part 1: Basics.',
          // subtitles: [
          //   'Effective content & email marketing strategies for lead generation',            
          // ]
        },
        {
          id: 4,
          title:
            'May 19 at Noon/12 PM EST: Session 4: Equity Risk Management - Part 2: Portfolios. ',
          // subtitles: [
          //   'Surprise Strategy to Win Over Clients in 2022',            
          // ]
        },
        {
          id: 5,
          title:
            'May 24 at Noon/12 PM EST: Session 5: Fixed Income Risk Management - Part 1: Risk Factors.',
          // subtitles: [
          //   'Surprise Strategy to Win Over Clients in 2022',            
          // ]
        },
        {
          id: 6,
          title:
            'May 26 at Noon/12 PM EST: Session 6: Fixed Income Risk Management - Part 2: Curves. ',
          // subtitles: [
          //   'Surprise Strategy to Win Over Clients in 2022',            
          // ]
        },
        {
          id: 7,
          title:
            'May 31 at Noon/12 PM EST: Session 7: Behavioral and Historical Aspects of Risk.',
          // subtitles: [
          //   'Risk Capacity',            
          // ]
        },
        {
          id: 8,
          title:
            'June 2 at Noon/12 PM EST: Session 8: Portfolio Stress Testing. ',
          // subtitles: [
          //   'Common pitfalls',            
          // ]
        },
        {
          id: 9,
          title:
            'June 7 at Noon/12 PM EST: Session 9: Advanced Topics: Cryptocurrency, Structured Notes, options, etc.',
          // subtitles: [
          //   'Surprise Strategy to Win Over Clients in 2022',            
          // ]
        },
        {
          id: 10,
          title:
            'June 9 at Noon/12 PM EST: Session 10: Winning Clients with Risk Management.',
          // subtitles: [
          //   'Surprise Strategy to Win Over Clients in 2022',            
          // ]
        },
      ],
      img: {
        gif: require('./gifntext 3-min.gif'),
      }
    }
  },
  methods: {
    closeModal() {
      this.$store.commit('setModal', false)
    },
    showModal() {
      this.$store.commit('setModal', true)
    }
  },
  created() {
    if (this.$route.query.modal) {
      this.$store.commit('setModal', true)
    }
  }
}
</script>

<style lang="scss">
.hero {
  margin-top: 40px;
  margin-bottom: 10rem;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  align-items: flex-start;

  &__image {
    margin-top: 20px;
    max-width: 350px;
    width: 100%;
    flex-grow: 1;
    flex-basis: 350px;
    object-fit: contain;
  }

  &__content {
    margin-top: 20px;
    flex-grow: 2;
    flex-basis: 500px;
    margin-left: 20px;

    .title {
      font-size: 3rem;
    }
  }

  &__cta {
    margin-top: 2rem;
    text-align: center;
  }

  .list {
    list-style: none;
    margin-top: 20px;

    &__item {
      font-size: 2.2rem;
      display: flex;
      font-weight: 400;      

      margin-bottom: 20px;
      display: flex;
      align-items: flex-start;
    }

    .simple-list {
      font-size: 2rem;
      font-weight: 300;
      margin-top: 5px;
      margin-left: 20px;
      list-style: disc;
    }

    &__count {
      font-size: 5rem;
      font-weight: 700;
      color: #f0b811;
      margin-right: 10px;
      line-height: 1;
      min-width: 70px;
    }

    &__text {
      height: 100%;
    }
  }
}
</style>
